export const buildDoctorAddress = (address, options = {}) => {
  const addressArray = [];

  if (address) {
    if (address.addressLine1 && !options.hideAddress) {
      addressArray.push(address.addressLine1);
    }
    if (address.addressLine2 && !options.hideAddress2 && !options.hideAddress) {
      addressArray.push(address.addressLine2);
    }
    if (address.addressLine3 && !options.hideAddress2 && !options.hideAddress) {
      addressArray.push(address.addressLine3);
    }
    const cityStateZipCounty = buildAddressCityStateCountry(address, options);
    if (cityStateZipCounty.length > 0) addressArray.push(cityStateZipCounty.join(', '));
  }
  return addressArray;
};
export const buildAddressCityStateCountry = (address, options = {}) => {
  const cityStateZipCounty = [];
  if (address) {
    const { city, postalCode, stateProvinceCode, country, country2Code } = address;
    if (city || stateProvinceCode || postalCode || country) {
      if (city && !options.hideCity) {
        cityStateZipCounty.push(`${city}`);
      }
      if (stateProvinceCode || postalCode) {
        cityStateZipCounty.push(
          `${stateProvinceCode && !options.hideStateProvince ? stateProvinceCode : ''} ${
            postalCode && !options.hideZip ? postalCode : ''
          }`.trim(),
        );
      }

      if ((country || country2Code) && country2Code !== 'US' && !options.hideCountry) {
        cityStateZipCounty.push(country || country2Code);
      }
    }
  }
  return cityStateZipCounty;
};
export const xPhoneNumbers = (phoneNumber) => {
  if (!phoneNumber) return phoneNumber;
  const match = phoneNumber.match(/(.*)([0-9].*?[0-9].*?[0-9].*?[0-9])/);
  if (match.length >= 3) return match[1] + match[2].replace(/[0-9]/g, 'X');
  else phoneNumber.replace(/[0-9]/g, 'X');
};
